var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_743_25317",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.3334C16.7364 17.3334 17.3333 16.7364 17.3333 16C17.3333 15.2637 16.7364 14.6667 16 14.6667C15.2636 14.6667 14.6667 15.2637 14.6667 16C14.6667 16.7364 15.2636 17.3334 16 17.3334ZM11.3333 17.3334C12.0697 17.3334 12.6667 16.7364 12.6667 16C12.6667 15.2637 12.0697 14.6667 11.3333 14.6667C10.597 14.6667 10 15.2637 10 16C10 16.7364 10.597 17.3334 11.3333 17.3334ZM20.6667 17.3334C21.403 17.3334 22 16.7364 22 16C22 15.2637 21.403 14.6667 20.6667 14.6667C19.9303 14.6667 19.3333 15.2637 19.3333 16C19.3333 16.7364 19.9303 17.3334 20.6667 17.3334Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_743_25317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8H24V24H8V8Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.7bed33f7.svg";
export { ForwardRef as ReactComponent };